module.exports = __webpack_public_path__ + "flyer_background_bbq_flames_110-af1b87a4e21ad2d4c81a956cb0a74ca3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Layouts/Backgrounds/flyer_background_bbq_flames_110.jpg
// module id = 1604
// module chunks = 1